import React from 'react';
import { Sprout } from 'lucide-react';
import { ASSETS } from '../config/constants';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  variant?: 'icon' | 'full';
}

export default function Logo({ 
  size = 'md', 
  showText = true, 
  variant = 'icon' 
}: LogoProps) {
  const sizes = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const logoUrl = variant === 'icon' ? ASSETS.LOGO.ICON : ASSETS.LOGO.FULL;

  return (
    <div className="flex items-center gap-2">
      {logoUrl ? (
        <img 
          src={logoUrl} 
          alt="Blooma Logo" 
          className={`${sizes[size]} ${variant === 'full' ? 'w-auto h-8' : ''}`}
        />
      ) : (
        // Fallback to Lucide icon if no logo uploaded
        <div className="bg-[#9CCC57] rounded-full p-2">
          <Sprout className={`${sizes[size]} text-white`} />
        </div>
      )}
      {showText && variant === 'icon' && (
        <span className="font-bold text-xl text-gray-800">Blooma</span>
      )}
    </div>
  );
}